const ACTIVE_HIGHLIGHT_COLOR = 'rgba(48, 196, 172, 0.9)';
const BUFFER_PAGES = 3;
const DEFAULT_PAGE_HEIGHT = 792;
const DEFAULT_PAGE_WIDTH = 612;
const HIGHLIGHT_COLOR = 'rgba(242, 232, 119, 0.9)';
const ORIGINAL_HIGHLIGHT_COLOR = 'rgba(167, 139, 250, 0.9)';
const SEARCH_HIGHLIGHT_COLOR = 'rgba(196, 181, 253, 0.8)';
const SEARCH_FOCUS_HIGHLIGHT_COLOR = 'rgba(253, 224, 71, 0.7)';

/**
 * Smooth-scroll only for jumps within this many viewport heights. A longer jump (e.g. a search
 * match far across the document) is done instantly — otherwise the smooth animation sweeps
 * through everything in between, mounting each page and spamming the image / page-text endpoints.
 * Shared with the audio transcript so both viewers navigate the same way.
 */
const SMOOTH_SCROLL_MAX_VIEWPORTS = 3;

export {
  ACTIVE_HIGHLIGHT_COLOR,
  BUFFER_PAGES,
  DEFAULT_PAGE_HEIGHT,
  DEFAULT_PAGE_WIDTH,
  HIGHLIGHT_COLOR,
  ORIGINAL_HIGHLIGHT_COLOR,
  SEARCH_HIGHLIGHT_COLOR,
  SEARCH_FOCUS_HIGHLIGHT_COLOR,
  SMOOTH_SCROLL_MAX_VIEWPORTS,
};
